export enum MachineRoleCode {
  'M-P',
  'M-B'
}
